"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CompoundCancelToken {
    constructor(...tokens) {
        this.tokens = tokens;
    }
    get cancel() {
        return this.tokens.find(x => x.cancel === true) ? true : false;
    }
}
exports.CompoundCancelToken = CompoundCancelToken;
function compoundCancelToken(...tokens) {
    return new CompoundCancelToken(...tokens);
}
exports.compoundCancelToken = compoundCancelToken;
function cancel(token) {
    token.cancel = true;
}
exports.cancel = cancel;
function reset(token) {
    token.cancel = false;
}
exports.reset = reset;
function cancelToken() {
    return { cancel: false };
}
exports.cancelToken = cancelToken;
class ResettableCancelToken {
    constructor() {
        this.cancelToken = cancelToken();
    }
    cancelAndReset() {
        cancel(this.cancelToken);
        this.cancelToken = cancelToken();
        return this.cancelToken;
    }
    get token() {
        return this.cancelToken;
    }
}
exports.ResettableCancelToken = ResettableCancelToken;
//# sourceMappingURL=cancel-token.js.map